import * as React from "react";
import { errorlog } from "../helpers/ErrorLogService";

export default class ProgressiveImageComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      image: props.placeholder,
      loading: true
    };
    this.image = null;
    this.loadImage = this.loadImage.bind(this);
    this.onLoad = this.onLoad.bind(this);
    this.onError = this.onError.bind(this);
  }

  componentDidMount() {
    const { src } = this.props;
    this.loadImage(src);
  }

  componentWillReceiveProps(nextProps) {
    const { src, placeholder } = nextProps;
    // We only invalidate the current image if the src has changed.
    if (src !== this.props.src) {
      this.setState({ image: placeholder, loading: true }, () => {
        this.loadImage(src);
      });
    }
  }

  componentWillUnmount() {
    if (this.image) {
      this.image.onload = null;
      this.image.onerror = null;
    }
  }

  loadImage(src) {
    // If there is already an image we nullify the onload
    // and onerror props so it does not incorrectly set state
    // when it resolves
    if (this.image) {
      this.image.onload = null;
      this.image.onerror = null;
    }
    const image = new Image();
    this.image = image;
    image.onload = this.onLoad;
    image.onerror = this.onError;
    image.src = src;
  };

  onLoad(){
    try {
    // use this.image.src instead of this.props.src to
    // avoid the possibility of props being updated and the
    // new image loading before the new props are available as
    // this.props.
    this.setState({
      image: this.image.src,
      loading: false
    });
  } catch (error) {
    //Error Severity: LOW
    errorlog(error, error.message, "ProgressiveImageComponent-onLoad")
  }
  };

  onError(errorEvent){
    try {
    const { onError } = this.props;
    if (onError) {
      onError(errorEvent);
    }
  } catch (error) {
    //Error Severity: LOW
    errorlog(error, error.message, "ProgressiveImageComponent-onError")
  }
  };

  render() {
    const { image, loading } = this.state;
    const { children } = this.props;
    if (!children || typeof children !== "function") {
      throw new Error(`ProgressiveImage requires a function as its only child`);
    }
    return children(image, loading);
  }
}


// WEBPACK FOOTER //
// ./src/components/ProgressiveImageComponent.js